<script>
  import { onMount } from 'svelte';
  import { location } from 'svelte-spa-router';

  let barcodeInput = '';
  let message = '';
  let device_id = 1;
  let inputRef;
  let currentCommand = null;
  let currentCommandMessage = '';
  let orderInfo = null;

  let commandTimeout = null;        //1분 후 오더넘버 바코드가 입력되지 않으면 메시지 삭제


  // ✅ 실시간 device_id 추적
  $: {
    const query = $location.split('?')[1];
    const params = new URLSearchParams(query);
    const value = parseInt(params.get('device'));
    if (!isNaN(value)) device_id = value;
  }

  onMount(() => {
    updateDeviceId();
    setTimeout(() => inputRef?.focus(), 100);

    setInterval(() => {
      if (document.activeElement !== inputRef) {
        inputRef?.focus();
      }
    }, 2000);

    window.addEventListener('hashchange', updateDeviceId);
    return () => window.removeEventListener('hashchange', updateDeviceId);
  });

  function updateDeviceId() {
    const hash = window.location.hash;
    const query = hash.split('?')[1];
    const params = new URLSearchParams(query);
    const value = parseInt(params.get('device'));
    if (!isNaN(value)) {
      device_id = value;
    }
  }

  async function handleBarcodeSubmit() {
    const trimmed = barcodeInput.trim();
    if (!trimmed) return;

    // 커맨드 처리
    if (/^LT-CMD-\d{3}$/.test(trimmed)) {
      currentCommand = trimmed;
      barcodeInput = '';

      if (trimmed === 'LT-CMD-001') {
        currentCommandMessage = '가공 시작합니다. 오더넘버를 스캔하세요';
      } else if (trimmed === 'LT-CMD-002') {
        currentCommandMessage = '가공 종료합니다. 오더넘버를 스캔하세요';
      } else {
        currentCommandMessage = '커맨드를 인식했습니다. 오더넘버를 스캔하세요';
      }

      message = '';
      orderInfo = null;

      clearTimeout(commandTimeout);
      commandTimeout = setTimeout(() => {
        currentCommandMessage = '';
      }, 60000);



      return;
    }

    // 오더넘버 스캔 처리
    const payload = { order_no: trimmed, device_id };

    if (currentCommand === 'LT-CMD-001') {
      payload.mode = 'process_start';
    } else if (currentCommand === 'LT-CMD-002') {
      payload.mode = 'process_end';
    } 

    const response = await fetch('/api/barcode-scan', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)      
    });

    const result = await response.json();
    console.log('📥 서버 응답:', result); // ✅ 여기 추가!

    // message = result.message || '처리 완료';
    currentCommandMessage = result.message || '처리 완료';
    //orderInfo = result.order || (result.rows?.[0] ?? null);
    orderInfo = typeof result.rows === 'object' ? result.rows : null;
    
    

    //타이머 제거
    clearTimeout(commandTimeout);
    commandTimeout = null;

    //currentCommandMessage = ''; // 커맨드 메시지 숨기기
    barcodeInput = '';
    currentCommand = null;
    inputRef?.focus();
  }

  
  function formatTimeToKST(isoString) {
    if (!isoString) return '-';
    const date = new Date(isoString);

    // KST 기준으로 시간 보정
    const kstDate = new Date(date.toLocaleString('en-US', { timeZone: 'Asia/Seoul' }));

    const year = kstDate.getFullYear();
    const month = String(kstDate.getMonth() + 1).padStart(2, '0');
    const day = String(kstDate.getDate()).padStart(2, '0');
    const hour = String(kstDate.getHours()).padStart(2, '0');
    const minute = String(kstDate.getMinutes()).padStart(2, '0');
    const second = String(kstDate.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
  }
  function formatDateToKST(isoString) {
    if (!isoString) return '-';
    const date = new Date(isoString);

    // KST 기준: UTC + 9시간
    const kstDate = new Date(date.getTime() + 9 * 60 * 60 * 1000);

    const yyyy = kstDate.getFullYear();
    const mm = String(kstDate.getMonth() + 1).padStart(2, '0');
    const dd = String(kstDate.getDate()).padStart(2, '0');

    return `${yyyy}-${mm}-${dd}`;
  }
</script>

<main class="hide-cursor">
  <h2>장비별 바코드 스캔</h2>

  <div class="device-input-group">
    <!-- svelte-ignore a11y-label-has-associated-control -->
    <label>장비 ID: {device_id}</label>
    <input
      type="text"
      bind:value={barcodeInput}
      bind:this={inputRef}
      placeholder="스캔 입력 후 Enter"
      on:keydown={(e) => e.key === 'Enter' && handleBarcodeSubmit()}
    />
  </div>


<!-- 항상 출력되는 영역들 -->
<div class="command-display">{currentCommandMessage}</div>

<!-- <p class="message-style">{message}</p> -->

<!-- 테이블은 빈 값일 때도 기본 구조 출력 -->
<div class="summary-wrapper">
  <table class="summary-table">
    <thead>
      <tr>
        <th>오더넘버</th>
        <th>거래처</th>
        <th>파트넘버</th>
        <th>프로젝트</th>
        <th>오더날짜</th>
        <th>납기예정</th>
        <th>수량</th>
        <th>장비ID</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>{orderInfo?.order_no ?? '-'}</td>
        <td>{orderInfo?.client_name ?? '-'}</td>
        <td>{orderInfo?.part_no ?? '-'}</td>
        <td>{orderInfo?.project_name ?? '-'}</td>
        <td>{formatDateToKST(orderInfo?.order_date)}</td>
        <td>{formatDateToKST(orderInfo?.due_date)}</td>
        <td>{orderInfo?.quantity ?? '-'}</td>
        <td>{orderInfo?.process_id ?? '-'}</td>
      </tr>
    </tbody>
  </table>
</div>

<div class="summary-wrapper" style="margin-top: 32px;">
  <table class="summary-table time-table">
    <thead>
      <tr>
        <th>가공시작</th>
        <th>가공종료</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>{formatTimeToKST(orderInfo?.process_start)}</td>
        <td>{formatTimeToKST(orderInfo?.process_end)}</td>
      </tr>
    </tbody>
  </table>
</div>

<!-- 바코드 이미지  -->
<div class="barcode-images">
  <img src="../images/barcode_ltcmd001.jpg" alt="Barcode 1" class="barcode left-barcode" />
  <img src="../images/barcode_ltcmd002.jpg" alt="Barcode 2" class="barcode right-barcode" />
</div>
<!-- 바코드 이미지  -->

</main>

<style>
  main{
    background-color: #f0f0f0; /* Light grey background */
    color: #333333; /* Dark text color */
    padding: 20px; /* Added padding for better spacing */
    box-sizing: border-box; /* Include padding in element's total width and height */
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 9999; /* Ensure it's on top */
  }
  .hide-cursor {
    cursor: none;
  }
  input {
    padding: 8px;
    font-size: 16px;
    width: 300px;
    background-color: #ffffff; /* Light input background */
    color: #333333; /* Dark input text */
    border: 1px solid #cccccc; /* Light border */
  }

  table {
    margin-top: 20px;
    border-collapse: collapse;
    width: 100%;
  }
  th, td {
    padding: 8px;
    border: 1px solid #cccccc; /* Light border for table cells */
    text-align: center;
    background-color: #ffffff; /* Default cell background */
    color: #333333; /* Default cell text */
  }
  th {
    background-color: #b6b69e; /* Dark blue header */
    color: #B6B69E; /* White text for header */
  }
  .device-input-group {
    display: flex;
    align-items: center;
    gap: 24px;
    margin-bottom: 16px;
  }



  .summary-wrapper {
    margin: 20px 0;
  }
  .summary-table {
    height: 120px;
    line-height: 2.2em;
  }
  .summary-table th, .summary-table td {
    border: 1px solid #cfcfca; /* Light border for tables */
    padding: 10px;
    text-align: center;
    font-size: 32px;
  }
  .summary-table th {
    background-color: #f1f1e8; /* Darker blue header */
    color: #5e5e4a; /* White text for header */
    font-weight: bold;
  }
  .summary-table td {
    background-color: #fcfcf8; /* White cell background */
    color: #5e5e4a; /* Dark text for cells */
    padding: 12px 8px;
  }
  .time-table td {
    font-size: 3em;
    font-weight: bold;
    height: 20vh;
  }

  .command-display {
    border: 1px solid #cfcfca; /* Light border for tables */
    background-color: #f1f1e8 !important;
    color: #0c9400 !important;
    font-size: 2.5rem;
    font-weight: bold;
    height: 12vh;
    text-align: center;
    padding: 20px 30px;
    margin: 16px auto;
    border-left: 8px solid #ffa000;
    border-right: 8px solid #ffa000;
    border-radius: 8px;
    box-shadow: none;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
  }

  /* 바코드 이미지  */
.barcode-images {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 40px;
  padding: 0 120px; /* 좌우 여백을 줄여 중앙으로 당김 */
}
.barcode {
  width: 24vw; /* 화면 너비의 12% */
  height: auto; /* 비율 유지 */
  object-fit: contain;
}

.left-barcode {
  margin-right: auto;
}
.right-barcode {
  margin-left: auto;
}
  /* 바코드 이미지  */

</style>